import DashboardLayout from '../layouts/DashboardLayout'

export const qrTransactionMenu = {
  path: '/qr-transactions',
  component: DashboardLayout,
  name: 'QR Transactions',
  redirect: '/qr-transactions',
  children: [
    {
      path: '/',
      name: 'QrTransactionList',
      component: () => import (/* webpackChunkName: "qr-transaction" */'../pages/qr-transaction/QrTransactionList.vue'),
      meta: {
        requiresAuth: true,
        roles: 'all',
        breadcrumb: [{
          title: 'Danh sách giao dịch QR',
        }],
        title: 'Danh sách giao dịch QR',
      },
    }
  ],
}

